export const friendlyLocation = (location: string, townName: string): string =>
    `${location} - ${townName || ""}`
        .replace("-Anadolu", "")
        .replace("-Avrupa", "")
        .replace(/(^\s* -)|( -\s*$)/g, "");

export const friendlyLocationLong = (location: string, townName: string): string =>
    `${location}${townName ? `-${townName}` : ""}`;
